import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store/index";
import account from '@/page/account/index'
import index from '@/page/index/index'
import home from '@/page/home/home'
import team from '@/page/team/teacher-team'
import work from '@/page/work/work-list'
import course from '@/page/course/course'
import plot from '@/page/plot/plot-pic'
import video from '@/page/plot/plot-video'
import about from '@/page/about/index'
import contact from '@/page/contact/contact'
import research from '@/page/research/research'
import business from '@/page/waibao/businessProfile'
import serviceCase from '@/page/waibao/serviceCase'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [{
      path: '/',
      component: account,
    },
    {
      path: '/login',
      component: account,
    },
    {
      path: '/index',
      component: index,
      children: [{
          path: '/home',
          component: home
        },
        {
          path: '/team',
          component: team
        },
        {
          path: '/work',
          component: work
        },
        {
          path: '/course',
          component: course
        },
        {
          path: '/plot',
          component: plot
        },
        {
          path: '/video',
          component: video
        },
        {
          path: '/about',
          component: about
        },
        {
          path: '/contact',
          component: contact
        },
        {
          path: '/research',
          component: research
        },
        {
          path: '/businessProfile',
          component: business
        },
        {
          path: '/serviceCase',
          component: serviceCase
        }
      ]
    },

  ]
})
/* router.beforeEach((to, from, next) => {
  const token = store.state.token
  if (to.matched.some(record => record.meta.noLogin)) {
    //路由元信息requireAuth:true，或者homePages:true，则不做登录校验
    next()
  } else {
    if (token) { //判断用户是否登录
      if (Object.keys(from.query).length === 0) { //判断路由来源是否有query，处理不是目的跳转的情况
        next()
      } else {
        let redirect = from.query.redirect //如果来源路由有query
        if (to.path === redirect) { //这行是解决next无限循环的问题
          next()
        } else {
          next({
            path: redirect
          }) //跳转到目的路由
        }
      }
    } else {
      if (to.path === "/login") {
        next({
          path: "/",
          query: {
            redirect: from.fullPath
          } //将目的路由地址存入login的query中
        })
      } else {
        next({
          path: "/",
          query: {
            redirect: to.fullPath
          } //将目的路由地址存入login的query中
        })
      }
    }
  }
  return
}) */
export default router



// WEBPACK FOOTER //
// ./src/router/index.js